import { render, staticRenderFns } from "./AddOrderMessage.vue?vue&type=template&id=3fcf914e&"
import script from "./AddOrderMessage.vue?vue&type=script&lang=js&"
export * from "./AddOrderMessage.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderMessage.vue?vue&type=style&index=0&id=3fcf914e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports